export default {
    loanAmtSelectedByUser: (desiredLoanAmountUpTo: number) => {
        return {
            name: "loanAmtSelectedByUser",
            valid: /\S/,
            errorText: `Please Enter valid amount up to ${desiredLoanAmountUpTo}`,
            moreValid: (target: any): boolean => {
                return target > desiredLoanAmountUpTo || target < 1;
            },
        };
    },
    ifsc: {
        name: "ifsc",
        valid: /\S/,
        errorText: `Please select ifsc code`,
    },
    kycCompliantAgree: {
        name: "kycCompliantAgree",
        valid: /^([Tt][Rr][Uu][Ee])$/,
        errorText: `Please Check`,
    },
    bankAccountType: {
        name: "bankAccountType",
        valid: /\S/,
        errorText: `Please Select Account Type`,
    },
    LDIAgree: {
        name: "LDIAgree",
        valid: /^([Tt][Rr][Uu][Ee])$/,
        errorText: `Please Check`,
    },
    insuranceNomineeName: {
        name: "insuranceNomineeName",
        valid: /\S/,
        errorText: `Please Enter Nominee Name`,
    },
    insuranceNomineeRelation: {
        name: "insuranceNomineeRelation",
        valid: /\S/,
        errorText: `Please Select a Nominee Relation`,
    },
};
